export default __webpack_public_path__ + "static/media/mail_icon.05348f40.svg";